var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInformation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.884,
    height: 18.884,
    viewBox: "0 0 18.884 18.884",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "information",
    d: "M9.442,0a9.442,9.442,0,1,0,9.442,9.442A9.453,9.453,0,0,0,9.442,0Zm.614,15.044c-.449.075-1.341.262-1.794.3a1.1,1.1,0,0,1-.966-.5,1.18,1.18,0,0,1-.143-1.081L8.937,8.852H7.082A2.218,2.218,0,0,1,8.828,6.789a6.833,6.833,0,0,1,1.794-.3,1.423,1.423,0,0,1,.966.5,1.18,1.18,0,0,1,.143,1.081L9.947,12.983H11.8a2.089,2.089,0,0,1-1.746,2.061ZM10.622,5.9a1.18,1.18,0,1,1,1.18-1.18,1.18,1.18,0,0,1-1.18,1.18Z",
    fill: "#2e86aa"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/information.c483621dabff196ac62ca95255a5fbb7.svg";
export { ForwardRef as ReactComponent };